module.exports = __webpack_public_path__ + "img/train2.458f20ba.jpg";